<template>
  <v-row class="d-flex justify-end">
    <v-col class="pt-0">
      <v-col :style="{ 'padding-left': padding }" class="py-0">
        <v-col
          cols="12"
          md="8"
          sm="6"
          xs="4"
          style="max-width: 100%"
          class="d-flex justify-space-between mx-auto pt-0"
        >
        </v-col>
        <v-card class="card_container mx-auto primary">
          <v-card-title class="d-flex justify-space-between">
            <v-text-field
              dense
              solo
              v-model="search"
              append-icon="mdi-magnify"
              :label="$tc('commons.search')"
              single-line
              hide-details
              class="search"
            />
            <v-col cols="auto" class="my-n4 pr-0">
              <v-row class="justify-start border ma-0">
                <!-- Botón de Refresh -->
                <v-col cols="auto pa-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="refreshItems"
                        class="btn-table ma-1"
                        small
                      >
                        <v-icon
                          :class="{ loader: loading4 }"
                          :loading="loading4"
                          :disabled="loading4"
                          id="icon-add"
                          class="mx-auto"
                          size="19"
                        >
                          fas fa-sync-alt
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $tc("commons.refresh") }}</span>
                  </v-tooltip>
                </v-col>

                <!-- Botón de Añadir -->
                <v-col cols="auto pa-0">
                  <div>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="white"
                          dark
                          icon
                          class="btn-table ma-1"
                          small
                        >
                          <v-icon
                            size="20"
                            class="mx-auto"
                            id="icon-add"
                            v-bind="attrs"
                            v-on="on"
                            @click="openDialog('add')"
                          >
                            fas fa-plus
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $tc("commons.add") }}</span>
                    </v-tooltip>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-card-title>
          <v-divider class="mt-1"></v-divider>
          <v-data-table
            :headers="headers"
            :items="paginatedItems"
            :single-expand="true"
            :expanded.sync="expanded"
            :title="title"
            item-key="name"
            show-expand
            hide-default-footer
            :search="search"
            class="mx-auto"
            @item-expanded="onExpand"
            fixed-header
            :height="calculateMaxHeight"
            @refreshItems="refreshItems"
          >
            <template v-slot:item.actions="{ item }">
              <div class="d-flex justify-space-around" style="width: 100px">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-btn icon>
                        <v-icon
                          id="icon-edit"
                          size="25"
                          @click="openDialog('addMovements', item)"
                        >
                          mdi-plus
                        </v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>{{ $tc("CurrentAccounts.addMovements") }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-btn icon>
                        <v-icon
                          id="icon-edit"
                          @click="openDialog('edit', item)"
                        >
                          fas fa-pen
                        </v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>{{ $tc("commons.edit") }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-btn icon>
                        <v-icon
                          id="icon-delete"
                          @click="openDialog('delete', item)"
                        >
                          fas fa-trash
                        </v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>{{ $tc("commons.delete") }}</span>
                </v-tooltip>
              </div>
            </template>

            <!-- Fila expandida -->
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers?.length" style="padding: 0px">
                <v-simple-table style="width: 100%">
                  <thead>
                    <tr>
                      <th class="th__title">
                        {{ $tc("CurrentAccounts.nameConcept") }}
                      </th>
                      <th class="th__title">
                        {{ $tc("CurrentAccounts.nameCsCost") }}
                      </th>
                      <th class="th__title">
                        {{ $tc("CurrentAccounts.typeMov") }}
                      </th>
                      <th class="th__title">
                        {{ $tc("CurrentAccounts.balance") }}
                      </th>
                      <th class="th__title">
                        {{ $tc("CurrentAccounts.haber") }}
                      </th>
                      <th class="th__title">
                        {{ $tc("CurrentAccounts.dateMov") }}
                      </th>
                      <th class="th__title">
                        {{ $tc("CurrentAccounts.dateLiqTable") }}
                      </th>
                      <th class="th__title">
                        {{ $tc("CurrentAccounts.excesoSup") }}
                      </th>
                      <th class="th__title">
                        {{ $tc("CurrentAccounts.excesoInf") }}
                      </th>
                      <th class="th__title">
                        {{ $tc("CurrentAccounts.debe") }}
                      </th>
                      <th class="th__title">
                        {{ $tc("CurrentAccounts.quantity") }}
                      </th>
                      <th class="th__title">
                        {{ $tc("CurrentAccounts.coments") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="movements.length === 0">
                      <td colspan="12" class="text-center">Sin movimientos</td>
                    </tr>
                    <tr v-else v-for="(mov, index) in movements" :key="index">
                      <td>{{ mov.concept }}</td>
                      <td>{{ mov.csCosto }}</td>
                      <td>{{ mov.typeMov }}</td>
                      <td>{{ mov.balance }}</td>
                      <td>{{ mov.haber }}</td>
                      <td>{{ mov.dateMov }}</td>
                      <td>{{ mov.dateLiq }}</td>
                      <td>{{ mov.excesoSup }}</td>
                      <td>{{ mov.excesoInf }}</td>
                      <td>{{ mov.debe }}</td>
                      <td>{{ mov.quantity }}</td>
                      <td>{{ mov.coment }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </td>
            </template>
          </v-data-table>
        </v-card>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col cols="12" md="8" lg="6">
            <v-pagination
              v-if="employees?.length > 0"
              class="paginado ma-0 pa-0"
              v-model="currentPage"
              :length="totalPages"
              prev-icon="mdi-chevron-left"
              next-icon="mdi-chevron-right"
              hide-delimiter-background
              :items-per-page="limit"
              @input="changePage"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-dialog
        v-model="open"
        :max-width="maxWidth[0]"
        persistent
        @keydown.esc="reset(false)"
        @keydown.enter="triggerSubmit"
      >
        <FormMovements
          v-if="this.typeAction === 'addMovements'"
          :allFields="parameters.items"
          @save="saveForm"
          @cancel="reset"
          :mode="mode"
          :show="true"
          @itemUpdate="dataSelectUpdate"
          :showVMask="showVMask"
          ref="formOrder"
        />
        <FormOrder
          v-else
          :allFields="parameters.items"
          @save="saveForm"
          @cancel="reset"
          :mode="mode"
          :show="true"
          :showDate="true"
          :showCheck="true"
          :employedOrigin="employeesSelected"
          :employeesWithSelectAll="employeesWithSelectAll"
          :infoEmployee="oldItems"
          ref="formOrder"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import FormOrder from "@/components/Complement/FormOrder";
import FormMovements from "../commons/FormMovements.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import currentAccounts from "@/store/currentAccounts/currentAccounts.js";
import employeeModel from "@/models/cuentasCorrientes/Relations/employees.js";
import date from "@/store/common/date";
import concepts from "@/store/conceptos/concepts";
import costCenters from "@/store/centrosDeCosto/costCenters";
import moment from "moment";

export default {
  components: {
    Table,
    FormOrder,
    FormMovements,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      loading4: false,
      movements: [],
      expanded: [],
      search: "",
      title: this.$tc("CurrentAccounts.employees"),
      titleTable: "Cuentas_Corrientes_Empleados",
      titleDelete: this.$tc("CurrentAccounts.toEmployeesAccount"),
      isLoading: true,
      maxWidth: ["580px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: null,
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Saldo",
          value: "balanceTable",
          class: "primary secondary--text",
          visible: true,
        },

        {
          text: "Desde",
          value: "dateStart",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Hasta",
          value: "dateEnd",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Tope Max",
          value: "topeMaxTable",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Tope Min",
          value: "topeMinTable",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "180px",
        },
      ],
      typeAction: null,
      idCostCenter: [],
      showVMask: false,
      currentPage: 1,
      limit: 20,
      order: "apellido",
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(
        currentAccounts.state.edit.employees.length / this.limit
      );
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.limit;
      const end = start + this.limit;
      return this.employees.slice(start, end);
    },
    calculateMaxHeight() {
      switch (true) {
        case this.movements?.length > 7:
          return "60vh";
      }
    },
    padding() {
      return currentAccounts.state.paddingNav;
    },
    items() {
      if (
        !currentAccounts.state.edit.employees ||
        currentAccounts.state.edit.employees.length === 0
      ) {
        return [];
      } else {
        return currentAccounts.state.edit.employees.map((item) => {
          return employeeModel.fromJson(item);
        });
      }
    },
    employees() {
      return this.$store.state.employees.employees;
    },
    employeesWithSelectAll() {
      return [
        { empId: "all", fullName: "Seleccionar todos", file: "" },
        ...this.employeesSelected,
      ];
    },
    employeesSelected() {
      const editEmpleados = currentAccounts.state.edit.employees;

      if (!editEmpleados || editEmpleados.length === 0) {
        return this.employees;
      }
      return this.employees.filter(
        (model) =>
          !editEmpleados.some((selected) => selected.empId === model.empId)
      );
    },
    parameters() {
      return {
        items: [
          {
            id: 1,
            show: true,
            data: currentAccounts.state.edit.unit !== "D" ? "00:00" : "",
            name: "topeMin",
            typeInput:
              currentAccounts.state.edit.unit === "D" ? "number" : "text",
            type: "text",
            label: this.$tc("CurrentAccounts.topeMin"),
            items: [],
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
              currentAccounts.state.edit.unit !== "D"
                ? (v) => {
                    const regex = /^-?(\d{1,3}):([0-5][0-9])$/;
                    if (!regex.test(v)) {
                      return this.$tc("CurrentAccounts.formatError", {
                        format: "000:00",
                      });
                    }
                    const [hours] = v.split(":").map(Number);
                    return (
                      (hours >= -1000 && hours <= 1000) ||
                      this.$tc("CurrentAccounts.formatError", {
                        min: -1000,
                        max: 1000,
                      })
                    );
                  }
                : (v) =>
                    (v >= -1000 && v <= 1000) ||
                    this.$tc("CurrentAccounts.topeMinError", {
                      min: -1000,
                      max: 1000,
                    }),
            ],
            order: 1,
          },
          {
            id: 2,
            show: true,
            data: currentAccounts.state.edit.unit !== "D" ? "00:00" : "",
            name: "topeMax",
            type: "text",
            typeInput:
              currentAccounts.state.edit.unit === "D" ? "number" : "text",
            label: this.$tc("CurrentAccounts.topeMax"),
            items: [],
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
              currentAccounts.state.edit.unit !== "D"
                ? (v) => {
                    const regex = /^(\d{1,3}):([0-5][0-9])$/;
                    if (!regex.test(v)) {
                      return this.$tc("CurrentAccounts.topeMaxError", {
                        format: "000:00",
                      });
                    }
                    const [hours] = v.split(":").map(Number);
                    return (
                      (hours >= 0 && hours <= 1000) ||
                      this.$tc("CurrentAccounts.topeMaxError", {
                        min: 0,
                        max: 1000,
                      })
                    );
                  }
                : (v) =>
                    (v >= 0 && v <= 1000) ||
                    this.$tc("CurrentAccounts.topeMaxError", {
                      min: 0,
                      max: 1000,
                    }),
            ],
            order: 2,
          },
          {
            id: 3,
            show: false,
            data: "",
            name: "saldo",
            type: "text",
            typeInput:
              currentAccounts.state.edit.unit === "D" ? "number" : "text",
            label: this.$tc("CurrentAccounts.balanceEmployeed"),
            items: [],
            rules: [],
            order: 3,
            disabled: true,
          },
          {
            id: 4,
            show: false,
            data: "",
            name: "conceptId",
            type: "select",
            label: this.$tc("CurrentAccounts.conceptLabel"),
            items: this.concepts,
            itemText: "nomConcepto",
            itemValue: "conceptoId",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 4,
          },
          {
            id: 5,
            show: false,
            data: "",
            name: "csCostoId",
            type: "select",
            label: this.$tc("CurrentAccounts.centroCostoLabel"),
            items: [],
            itemText: "name",
            itemValue: "id",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 5,
          },
          {
            id: 6,
            show: false,
            data: "",
            name: "comentario",
            type: "text",
            label: this.$tc("CurrentAccounts.comentLabel"),
            items: [],
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 6,
          },
          {
            id: 7,
            show: false,
            data: "",
            name: "cantidad",
            type: "text",
            typeInput: "number",
            label: this.$tc("CurrentAccounts.quantityLabel"),
            items: [],
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
              (v) => v >= 1 || this.$tc("CurrentAccounts.noNegative"),
            ],
            order: 7,
          },
        ],
      };
    },
    mode: {
      get() {
        return currentAccounts.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return currentAccounts.state.openFormRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return currentAccounts.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    concepts() {
      return currentAccounts.state.edit.concepts || [];
    },
  },
  async mounted() {
    await Promise.all([
      this.$store.dispatch("employees/getEmployees", {
        photo: false,
        order: this.order,
        soloActivos: true,
      }),
      concepts.dispatch("getConcepts"),
      costCenters.dispatch("getCostCenters"),
    ]);
    this.isLoading = false;
  },
  methods: {
    changePage(page) {
      this.currentPage = page;
    },

    triggerSubmit() {
      if (this.$refs.formOrder) {
        this.$refs.formOrder.submitForm();
      }
    },

    async onExpand(item) {
      const payload = {
        accountId: currentAccounts.state.edit.accountId,
        empId: item.item.empId,
        dateStart: item.item.dateStartInput,
      };
      await currentAccounts.dispatch("getMovements", payload);
      this.movements = currentAccounts.state.movements;
    },

    async refreshItems() {
      this.loading4 = true;
      try {
        if (currentAccounts.state.edit.accountId) {
          await currentAccounts.dispatch(
            "getAccountId",
            currentAccounts.state.edit.accountId
          );
        }
      } finally {
        setTimeout(() => {
          this.loading4 = false;
        }, 2000);
      }
    },

    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 5000);
    },

    costCenters() {
      const matchedItems = [];
      const costCentersArray = costCenters.state.costCenters;

      for (let i = 0; i < this.idCostCenter.length; i++) {
        const id = this.idCostCenter[i];
        const item = costCentersArray.find((center) => center.id === id);
        if (item) {
          matchedItems.push(item);
        }
      }
      return matchedItems;
    },

    dataSelectUpdate(item) {
      if (item.name === "conceptId") {
        const conceptsSelected = currentAccounts.state.edit.concepts.filter(
          (element) => element.conceptoId === item.data
        );

        const costCenterIds = conceptsSelected.map(
          (concept) => concept.csCostoId
        );
        this.idCostCenter = costCenterIds;

        this.parameters.items[5].items = this.costCenters();
      }
    },

    addEmployee(form) {
      let payload = form;
      if (currentAccounts.state.edit.unit !== "D") {
        payload.topeMin = this.convertToMinutes(form.topeMin);
        payload.topeMax = this.convertToMinutes(form.topeMax);
      }
      payload.dateStart = date.state.dateFrom;
      payload.dateEnd = date.state.dateTo;
      payload.accountId = currentAccounts.state.edit.accountId;
      currentAccounts.commit("setNew", payload);
      return new Promise((resolve, reject) => {
        currentAccounts
          .dispatch("addEmployees")
          .then(() => {
            this.showAlert(
              this.$tc("CurrentAccounts.addEmployeeToAccountSuccess"),
              "#82A1D0"
            );
            resolve();
            this.reset(false);
          })
          .catch((error) => {
            this.showAlert(
              this.$tc("CurrentAccounts.errorEmployee"),
              "#ff8d58"
            );
            this.reset(false);
            reject(error);
          });
      });
    },

    editEmployee(form) {
      let payload = this.detectChanges(form);
      if (Object.keys(payload).length > 0) {
        payload.accountId = currentAccounts.state.edit.accountId;
        payload.fecDesdeOld = this.oldItems.dateStartInput;
        payload.empId = this.oldItems.empId;

        currentAccounts.commit("setEditRelation", payload);
        currentAccounts
          .dispatch("editEmployees")
          .then(() => {
            this.showAlert(
              this.$tc("CurrentAccounts.editEmployeeToAccountSuccess"),
              "#82A1D0"
            );
          })
          .catch(() => {
            this.showAlert(
              this.$tc("CurrentAccounts.errorEmployee"),
              "#ff8d58"
            );
          });
      }

      this.reset(false);
    },

    detectChanges(newItems) {
      newItems.dateStartInput = date.state.dateFrom;
      newItems.dateEndInput = date.state.dateTo;

      const changes = {};

      if (this.oldItems.dateStartInput !== newItems.dateStartInput) {
        changes.dateStartInput = newItems.dateStartInput;
      }

      if (this.oldItems.dateEndInput !== newItems.dateEndInput) {
        changes.dateEndInput = newItems.dateEndInput;
      }

      this.checkTopeMinChange(this.oldItems.topeMin, newItems.topeMin, changes);

      this.checkTopeMaxChange(this.oldItems.topeMax, newItems.topeMax, changes);

      return changes;
    },

    checkTopeMinChange(oldValue, newValue, changes) {
      const unit = currentAccounts.state.edit.unit;
      const oldMinutes =
        unit !== "D" ? this.convertToMinutes(oldValue) : oldValue;
      const newMinutes =
        unit !== "D" ? this.convertToMinutes(newValue) : Number(newValue);

      if (newMinutes !== oldMinutes) {
        if (newMinutes < oldMinutes) {
          changes.topeMin = newMinutes;
        } else if (newMinutes >= oldMinutes) {
          this.showAlert(
            this.$tc("CurrentAccounts.errorEditTopeMin"),
            "#ff8d58"
          );
        }
      }
    },

    checkTopeMaxChange(oldValue, newValue, changes) {
      const unit = currentAccounts.state.edit.unit;
      const oldMinutes =
        unit !== "D" ? this.convertToMinutes(oldValue) : oldValue;
      const newMinutes =
        unit !== "D" ? this.convertToMinutes(newValue) : Number(newValue);

      if (newMinutes !== oldMinutes) {
        if (newMinutes > oldMinutes) {
          changes.topeMax = newMinutes;
        } else if (newMinutes <= oldMinutes) {
          this.showAlert(
            this.$tc("CurrentAccounts.errorEditTopeMax"),
            "#ff8d58"
          );
        }
      }
    },

    async openDialog(type, item) {
      this.typeAction = type;
      switch (type) {
        case "add":
          this.parameters.items[0].show = true;
          this.parameters.items[1].show = true;
          this.parameters.items[2].show = false;
          this.parameters.items[3].show = false;
          this.parameters.items[4].show = false;
          this.parameters.items[5].show = false;
          this.parameters.items[6].show = false;
          date.state.checkTo = true;
          currentAccounts.commit(
            "setModeFormRelation",
            this.$tc("CurrentAccounts.addEmployeesToAccount")
          );
          currentAccounts.commit("setOpenFormRelation", true);
          this.showVMask = false;
          break;
        case "edit":
          this.oldItems = item;
          this.parameters.items[0].data = item.topeMin;
          this.parameters.items[1].data = item.topeMax;
          this.parameters.items[0].show = true;
          this.parameters.items[1].show = true;
          this.parameters.items[2].show = false;
          this.parameters.items[3].show = false;
          this.parameters.items[4].show = false;
          this.parameters.items[5].show = false;
          this.parameters.items[6].show = false;
          await this.setEdit(item);
          currentAccounts.commit(
            "setModeFormRelation",
            this.$tc("CurrentAccounts.editEmployeesToAccount")
          );
          currentAccounts.commit("setOpenFormRelation", true);
          this.showVMask = false;
          break;
        case "delete":
          currentAccounts.commit("setOpenDelete", true);
          this.itemToDelete = {
            ...item,
            accountId: currentAccounts.state.edit.accountId,
          };
          break;
        case "addMovements":
          this.oldItems = item;
          this.parameters.items[0].data = [item.empId];
          this.parameters.items[0].items = this.employees;
          this.parameters.items[0].label = this.$tc(
            "CurrentAccounts.nameEmployeed"
          );
          this.parameters.items[0].disabled = true;
          this.parameters.items[0].show = true;
          this.parameters.items[1].show = false;
          this.parameters.items[2].show = false;
          this.parameters.items[3].show = true;
          this.parameters.items[3].data = item.balanceTable;
          this.parameters.items[4].show = true;
          this.parameters.items[5].show = true;
          this.parameters.items[6].show = true;
          currentAccounts.commit("setOpenFormRelation", true);
          currentAccounts.commit(
            "setModeFormRelation",
            this.$tc("CurrentAccounts.addMovements")
          );
          currentAccounts.state.edit.unit === "D"
            ? ((this.parameters.items[7].show = true), (this.showVMask = false))
            : ((this.parameters.items[7].show = false),
              (this.showVMask = true));
          break;
        case "detailMovements":
          currentAccounts.commit("setOpenFormRelation", true);

          break;
        default:
          break;
      }
    },

    convertToTime(minutes) {
      const isNegative = minutes < 0;
      const absoluteMinutes = Math.abs(minutes);

      const hours = Math.floor(absoluteMinutes / 60)
        .toString()
        .padStart(2, "0");
      const mins = (absoluteMinutes % 60).toString().padStart(2, "0");

      return `${isNegative ? "-" : ""}${hours}:${mins}`;
    },

    setEdit(item) {
      if (item.dateEndInput) {
        date.state.checkTo = false;
        date.state.dateTo = item.dateEndInput;
      } else {
        date.state.checkTo = true;
      }
      date.state.dateFrom = item.dateStartInput;
    },

    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    reset(value) {
      currentAccounts.commit("setOpenFormRelation", value);
      this.oldItems = null;
      this.resetDate();
      currentAccounts.state.hours = "";
      currentAccounts.state.dateLiq = moment.utc().format("YYYY-MM-DD");
      this.parameters.items.forEach((item) => {
        item.data = "";
      });
    },

    saveForm(items) {
      switch (this.typeAction) {
        case "add":
          this.addEmployee(items);
          break;
        case "edit":
          this.editEmployee(items);
          break;
        case "addMovements":
          this.addMovements(items);
          break;
        default:
          break;
      }
    },

    convertToMinutes(timeString) {
      const [hours, minutes] = timeString.split(":").map(Number);
      return hours * 60 + minutes;
    },

    addMovements(item) {
      const payload = this.preparePayload(item);
      const concept = this.findConcept(item);

      if (!concept) {
        this.showAlert(
          this.$tc("CurrentAccounts.errorConceptNotFound"),
          "#ff8d58"
        );
        return;
      }

      const cantidad = this.calculateCantidad(item, payload);
      const result = this.calculateResult(concept, cantidad);

      if (concept.debCred === "D") {
        this.handleDebit(result, payload);
      } else {
        this.handleCredit(result, payload);
      }
    },

    preparePayload(item) {
      const payload = {
        accountId: currentAccounts.state.edit.accountId,
        fechaLiq: currentAccounts.state.dateLiq,
        empId: this.oldItems.empId,
        ...item,
      };

      if (
        !item.hasOwnProperty("cantidad") &&
        typeof currentAccounts.state.hours === "string"
      ) {
        payload.cantidad = this.convertToMinutes(currentAccounts.state.hours);
      }

      if (currentAccounts.state.edit.unit !== "D") {
        this.convertOldItemTimes();
      }

      return payload;
    },

    findConcept(item) {
      return this.concepts.find(
        (concept) =>
          concept.conceptoId === Number(item.conceptId) &&
          concept.csCostoId === Number(item.csCostoId)
      );
    },

    convertOldItemTimes() {
      if (typeof this.oldItems.balance === "string") {
        this.oldItems.balance = this.convertToMinutes(this.oldItems.balance);
      }
      if (typeof this.oldItems.topeMin === "string") {
        this.oldItems.topeMin = this.convertToMinutes(this.oldItems.topeMin);
      }
      if (typeof this.oldItems.topeMax === "string") {
        this.oldItems.topeMax = this.convertToMinutes(this.oldItems.topeMax);
      }
    },

    calculateCantidad(item, payload) {
      return item.cantidad ? Number(item.cantidad) : payload.cantidad;
    },

    calculateResult(concept, cantidad) {
      const formula = concept.paramA + concept.paramB * cantidad;
      return concept.debCred === "D"
        ? this.oldItems.balance - formula
        : this.oldItems.balance + formula;
    },

    handleDebit(result, payload) {
      if (result > this.oldItems.topeMin) {
        this.processMovement(payload);
      } else {
        this.showAlert(this.$tc("CurrentAccounts.errorTopeMin"), "#ff8d58");
      }
    },

    handleCredit(result, payload) {
      if (result < this.oldItems.topeMax) {
        this.processMovement(payload);
      } else {
        this.showAlert(this.$tc("CurrentAccounts.errorTopeMax"), "#ff8d58");
      }
    },

    processMovement(payload) {
      currentAccounts.commit("setEditRelation", payload);
      currentAccounts
        .dispatch("addMovement")
        .then(async () => {
          this.showAlert(
            this.$tc("CurrentAccounts.addMovementToAccountSuccess"),
            "#82A1D0"
          );
          await this.updateMovements();
          this.reset(false);
        })
        .catch((error) => {
          this.showAlert(error.response.data.error.message, "#ff8d58");
        });
    },

    async updateMovements() {
      const data = {
        accountId: currentAccounts.state.edit.accountId,
        empId: this.oldItems.empId,
        dateStart: this.oldItems.dateStartInput,
      };
      await currentAccounts.dispatch("getMovements", data);
      this.movements = currentAccounts.state.movements;
    },

    deleteItem() {
      currentAccounts.commit("setItemDelete", this.itemToDelete);
      currentAccounts
        .dispatch("deleteEmployees")
        .then(() => {
          this.openDelete = false;
          currentAccounts.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("CurrentAccounts.deleteEmployeeToAccountSuccess"),
            "#82A1D0"
          );
        })
        .catch(() => {
          this.showAlert(this.$tc("CurrentAccounts.errorEmployee"), "#ff8d58");
        });
    },

    cancelDelete() {
      this.openDelete = false;
      currentAccounts.commit("setOpenDelete", false);
    },
  },
};
</script>
<style>
.border {
  background-color: #1f324a2f;
  border-color: #a5b9d7;
  border-width: 5px;
  border-style: solid;
  border-radius: 25px;
}
.btn-table {
  background-color: #82a1d0;
}
.loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.th__title {
  background-color: #7692bc !important;
  color: white !important;
}
.v-data-table-header th {
  background-color: #82a1d0 !important;
}
#icon-add {
  color: #ffffff;
  margin-right: 8px;
}
#icon-edit {
  color: #39537a;
  font-size: 20px;
}
#icon-delete {
  color: #e2504c;
  font-size: 20px;
}
.search {
  max-width: 500px !important;
}
.v-data-table--fixed-header > .v-data-table__wrapper {
  overflow-y: scroll;
  scrollbar-width: unset;
}
</style>
